import React from 'react'
import IconPlus from '@tecuity/sos-icons/react/plus'
import { EditCategoryModal } from '../Home/Home'
import Portal from 'components/Portal/Portal'
import { Modal } from '../Modal/Modal'
import './AddCategoryCard.scss'

const AddCategoryCard = ({ onCategoryAdded }) => {
  const [isAdding, setIsAdding] = React.useState(false)
  const editModal = React.useRef()

  const handleSave = () => {
    const category = editModal.current.getValues();
    onCategoryAdded(category)
  }

  return (
    <React.Fragment>
      <div className="edit-icon-wrapper flex-column center">
        <div className="edit-icon-positioner">
          <button className="edit-icon-wrapper" onClick={() => setIsAdding(true)} aria-label="Add Category Card">
            <IconPlus />
          </button>
        </div>
      </div>
      <Portal isOpened={isAdding}>
        <Modal
          title={`Add Category`}
          modalSize="large"
          save={handleSave}
          saveAndCloseButton
          cancelButton
          closeModal={() => setIsAdding(false)}
        >
          <EditCategoryModal
            ref={editModal}
            id="new"
            title=""
            description=""
            links={[
              {
                label: "",
                href: ""
              },
              {
                type: "separator"
              },
              {
                label: "",
                href: ""
              }
            ]}
            icon="capital"
            disabled={false}
          />
        </Modal>
      </Portal>
    </React.Fragment>
  )
}

export default AddCategoryCard
